import { useQuery } from '@tanstack/react-query';

import { ApiRoutes, QueryKeyEnum, TimeEnum } from '@lib/enums';
import { useHttp } from '@lib/http';

import type { QuoteStatusEnum, SalePendingTagEnum } from '@lib/enums';
import type { UseQueryResult } from '@tanstack/react-query';

export type TCallDetailsRequest = {
  ecommerceExternalCallId?: Maybe<string>;
  contactMasterId?: Maybe<string>;
  leadId?: Maybe<string>;
  transferQuoteId?: Maybe<string>;
};

export type TDialerLeadPreview = {
  firstName: Maybe<string>;
  lastName: Maybe<string>;
  emailAddress: Maybe<string>;
  city: Maybe<string>;
  state: Maybe<string>;
  zip: Maybe<string>;
  phoneNumber: Maybe<string>;
  vehicleMake: Maybe<string>;
  vehicleModel: Maybe<string>;
  vehicleYear: Maybe<string>;
  vehicleVin: Maybe<string>;
  vehicleMileage: Maybe<string>;
  moxyCustomerNumber: Maybe<string>;
};

export type TCallDetailsResponse = {
  quoteId: Maybe<string>;
  leadId: Maybe<string>;
  consumerId: Maybe<string>;
  consumerVehicleId: Maybe<string>;
  contractNumber: Maybe<string>;
  quoteStatus?: Maybe<QuoteStatusEnum>;
  salePendingTag?: Maybe<SalePendingTagEnum>;
  dialerLeadPreview?: TDialerLeadPreview;
  ecommerceSessionId?: Maybe<string>;
  scriptKey: Maybe<string>;
};

export function useQueryCallDetails(
  query: TCallDetailsRequest,
  options: object = {},
): UseQueryResult<TCallDetailsResponse, Error> {
  const { http } = useHttp();

  return useQuery({
    queryKey: [QueryKeyEnum.CallDetails, query],
    queryFn: () => http.get(ApiRoutes.Contacts.CallDetails, query).sendx<TCallDetailsResponse>(),
    staleTime: TimeEnum.FiveMinutes,
    ...options,
  });
}
